import { Teacher } from 'kuaidong-model'
import { ATeacher, AUser } from 'kuaidong-api'
import { AppUtil, EnvUtil } from 'kuaidong-lib'
import { TeacherService } from './TeacherService'

/**
 * 当前登录用户的状态和信息获取
 */
export class LoginTeacherService {
  static hasFetchedTeacher = false // 是否已经尝试拿到登录用户信息
  static loginTeacher: Teacher | null = null
  static loginTeacherId: string | null

  public static async getLoginTeacherId(): Promise<string> {
    if (!this.loginTeacherId) {
      if (!EnvUtil.isApph5() && !EnvUtil.isISC()) {
        this.loginTeacherId = (await AUser.loginByH5Token()).teacher_id || ''
      } else {
        if (await AppUtil.isUnderApp()) {
          this.loginTeacherId = await (await AppUtil.getUserData()).user_id
        }
      }
    }

    return this.loginTeacherId || ''
  }

  public static async getLoginTeacher(): Promise<Teacher | null> {
    if (!this.loginTeacher) {
      this.hasFetchedTeacher = true
      this.loginTeacher = await ATeacher.find()
    }
    return this.loginTeacher
  }

  // 判断的当前用户是否已经登录
  public static async isLoged(): Promise<boolean> {
    const teacher = await this.getLoginTeacher()
    return !!teacher
  }

  // 确保得到登录用户，没登录则报错
  public static async forceGetLoginTeacher(): Promise<Teacher> {
    const teacher = await this.getLoginTeacher()
    if (!teacher) {
      throw new Error('teacher not login!')
    } else {
      return teacher
    }
  }

  public static async forceGetLoginTeacherId(): Promise<string> {
    const teacher = await this.forceGetLoginTeacher()
    return teacher.teacher_id
  }

  public static async getCallName(): Promise<string> {
    const ts = new TeacherService(await this.forceGetLoginTeacher())
    return ts.callName
  }

  // 不会多次发送请求，且保证返回 string
  public static async safeGetTeacherId(): Promise<string> {
    try {
      return this.getLoginTeacherId()
    } catch (e) {
      return ''
    }
  }
}
